var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$myApp.config.underConstruction)?_c('v-alert',{staticClass:"mt-5 mx-1",attrs:{"close-text":"Close Alert","dark":"","type":_vm.type,"dismissible":_vm.dismissable},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }